module.exports = new __parcel__URL__("ErrorWindow.150cf151.svg").toString();